import { setupInfiniteScroll, setupGenericSearch } from '../../utils/common.js';

// Inicialização da listagem de fornecedores
$(document).ready(function() {
    // Listagem com scroll infinito
    let pagination;
    if ($('.tbodySuppliers').length) {
        pagination = setupInfiniteScroll('.tbodySuppliers', '/fornecedores', '#currentPage');
    }

    // Funcionalidade de busca
    if ($('#searchSupplier').length) {
        setupGenericSearch(
            '#searchSupplier',
            '/fornecedores/search',
            '.table-supplier',
            '.tbodySuppliers',
            // Sem filtros extras por enquanto
            () => ({})
        );
    }

    // Sincronizar paginação com resultados da busca
    $(document).on('search:success', function(e, response, searchData) {
        if (pagination) {
            pagination.config.loadUrl = window.location.pathname;
            pagination.config.extraParams = searchData;
            pagination.reset();
        }
    });
});
